// Module
var code = "<div layout=\"column\" class=\"full-height\"> <div flex class=\"full-height overflow-auto\" ui-view> <logistics-vehicle-info logistics-vehicle=\"$ctrl.logisticsVehicle\"></logistics-vehicle-info> </div> </div> ";
// Exports
export default code;